import { debounce } from 'lodash-es';
import { useMemo, useState } from 'react';

export function useDebouncedValue<T>(wait: number = 500, defaultValue?: T) {
  const [value, setValue] = useState<T | undefined>(defaultValue);

  const throttleFn = useMemo(() => debounce(setValue, wait), [wait]);

  return {
    setValue: throttleFn,
    value: value,
  };
}
